module.exports = __webpack_public_path__ + "static/media/akro studio logo png.6ddeb2e3.png";